
export const subscribeToPopupOpen = (editor, {onPopupOpen}) => {
    editor.subscribe(
        // @ts-ignore
        CustomersCanvas.IframeApi.PostMessage.Events.PopupOpen,
        onPopupOpen
    );
};

export const subscribeToItemsChanged = (editor, {onItemChanged}) => {
    editor.subscribe(
        // @ts-ignore
        CustomersCanvas.IframeApi.PostMessage.Events.ItemChanged,
        onItemChanged
    );
};

export const subscribeToItemsAdded = (editor, {onItemAdded}) => {
    editor.subscribe(
        // @ts-ignore
        CustomersCanvas.IframeApi.PostMessage.Events.ItemAdded,
        onItemAdded
    );
};

// calls onSurfaceChanged whenever the surface changes within the editor - this happens when using the buttons to change
// surfaces, such as "OUTSIDE" and "INSIDE", or when using the product.switchTo method from the Iframe API - this also
// happens when changing the photo style - this is NOT triggered automatically upon initialization
// onSurfaceChanged receives params: surfaceId
export const subscribeToSurfaceChanged = (editor, {onSurfaceChanged}) => {
    editor.subscribe(
        // @ts-ignore
        CustomersCanvas.IframeApi.PostMessage.Events.OnSurfaceChanged,
        onSurfaceChanged
    );
};
